var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isFixed)?_c('div',{style:(("height: " + _vm.offsetHeight + "px;"))}):_vm._e(),_c('div',{class:{ 'position-fixed width-full top-0': _vm.isFixed },staticStyle:{"z-index":"20"},attrs:{"id":"sticky"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }